export default __webpack_public_path__ + "static/media/DeminMv.03f80c2d.webp";